export const routes = [
  {
    path: "/",
    name: "首页",
    text: "首页",
    component: () => import( "../views/index")
  },
  {
    path: "/projects",
    name: "项目列表",
    text: "项目列表",
    component: () => import("../views/projects/index")
  },
  {
    path: "/projects/members/:projectId",
    name: "项目成员",
    text: "项目成员",
    component: () => import( "../views/projects/members")
  }
];
